<template>
    <div class="content content-fixed content-auth-alt">
        <div class="container d-flex justify-content-center ht-100p">
            <div class="mx-wd-1000 wd-sm-1050 ht-100p d-flex flex-column align-items-center justify-content-center">
                <div class="wd-80p wd-sm-300 mg-b-15">
<!--                    <p style="font-size: 50px;"><b-icon-arrow-left v-if="company.screen !== 'stepOne'" style="position: absolute; left: 30%; cursor: pointer;" @click="navigateProp('stepOne')"></b-icon-arrow-left></p>-->
                    <router-link to="/">
                        <h1 class="title"><a href="#" class="aside-logo"><img src="https://qusquare.com/Images/logo.png" height="50px" width="60px"/></a>QooSquare</h1>
                        <!--                    <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/logo.png" class="img-fluid" alt="">-->
                </router-link></div>
<!--                <h4 class="tx-20 tx-sm-24">{{$t('sidebar.addNewAccount')}}</h4> <p align="center" @click="navigate" v-if="company.companies.length > 0" style="font-size: 12px; cursor: pointer">{{$t('miscellaneous.backToDashboard')}}</p>-->
                <create-company-form style="border-color: transparent;"></create-company-form>
            </div>
        </div><!-- container -->
    </div><!-- content -->
</template>

<script>
    import CreateCompanyForm from "../../components/form/CreateCompanyForm";
    import {mapState} from 'vuex'
    // import store from "../../store/store";
    export default {
        name: "Forgot",
        components:{
            CreateCompanyForm
        },
        methods:{
            navigate(){
                // window.location = '/dashboard'
                this.$router.push('/onboarding/dashboard')
            },
            navigateProp(screen){
                this.$store.dispatch('company/updateScreen', screen, {root: true})
            },
            officerFilteredByUserId(_item) {
                return this.officer.officers.filter(function (el) {
                    return el.officerUserID == _item;
                });
            },
        },
        created() {
            //this.initDashboard()
        },
        computed:{
            ...mapState([
                'company',
                'system',
            ])
        }
    }
</script>

<style scoped>

</style>